/**
 * @author Goutam Shetty <goutam.shetty@314ecorp.com>
 * @description Centralized Day.js wrapper with plugins
 */

import dayjs, { Dayjs } from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(relativeTime);
// You can add more plugins here as needed

export default dayjs;
export type { Dayjs };
